import { Activity } from "lucide-react";

const activity = [
    {
        title: "Quotation approved",
        detail: "EV Battery Enclosure v2 · ₹82,400",
        time: "5m",
        color: "bg-green-100 text-green-600",
    },
    {
        title: "Machine booked",
        detail: "5-Axis CNC · Nov 22 09:00–13:00",
        time: "18m",
        color: "bg-blue-100 text-blue-600",
    },
    {
        title: "Quality inspection passed",
        detail: "Agri Drone Chassis · Batch 04",
        time: "42m",
        color: "bg-green-100 text-green-600",
    },
    {
        title: "Maintenance due",
        detail: "PCB Prototyping Machine · in 2 days",
        time: "1h",
        color: "bg-orange-100 text-orange-500",
    },
    {
        title: "New prototype request",
        detail: "IoT Smart Water Sensor · Tirupati",
        time: "2h",
        color: "bg-purple-100 text-purple-600",
    },
];

export default function LiveActivity() {
    return (
        <div className="divide-y divide-slate-100">
            {activity.map((item, index) => (
                <div
                    key={index}
                    className="flex items-start gap-3 px-6 py-4"
                >
                    <div
                        className={`w-9 h-9 rounded-lg flex items-center justify-center shrink-0 ${item.color}`}
                    >
                        <Activity size={16} />
                    </div>

                    <div className="flex-1 min-w-0">
                        <p className="font-semibold text-sm text-slate-900">
                            {item.title}
                        </p>
                        <p className="text-slate-500 text-sm mt-0.5 truncate">
                            {item.detail}
                        </p>
                    </div>

                    <span className="text-xs text-slate-400 shrink-0 mt-0.5">
                        {item.time}
                    </span>
                </div>
            ))}
        </div>
    );
}